export default __webpack_public_path__ + "static/media/logo.233e42df.png";